export class StripeService {
    

    constructor(){

    }


    async createPaymentIntent(rateCycle: string, 
        amount: number, 
        description: string, 
        policyNumber:string, 
        emailAddress: string, 
        name:string) {

        var baseApi = process.env.REACT_APP_BASE_API_URL ?? "";
        var paymentIntentUrl = process.env.REACT_APP_API_INTEGRATION_STRIPE_CREATEPAYMENT_INTENT ?? "";
        var createIntentApiUrl = baseApi + paymentIntentUrl;
        
        return fetch(createIntentApiUrl, {
            mode: "cors",
            method: "POST",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
            },
            body: JSON.stringify({ 
                rateCycle: rateCycle,
                description: description,
                amount: amount,
                policyNumber: policyNumber,
                emailAddress: emailAddress,
                customerName: name

            }),
          });
    }
    

    async getPaymentIntent(paymentIntentId: string, rateCycle:string) {
        var baseApi = process.env.REACT_APP_BASE_API_URL ?? "";
        var endpoint = process.env.REACT_APP_API_INTEGRATION_STRIPE_GETPAYMENT_INTENT ?? "";
        var apiUrl = (baseApi + endpoint).replace("{id}", paymentIntentId).replace("{rateCycle}", rateCycle);
        
        var response = await fetch(apiUrl, {
            mode: "cors",
            method: "GET",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
            },
          });

        if(response.ok) {
            return {
                ok: true,
                data: await response.json()
            }
        }else{
            return {
                ok: false,
                error: await response.text()
            }
        }
    }
    
}